import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-10",
  "use": "icon-sheet_icon-10-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-10\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M9.305 3A9.236 9.236 0 003 11.766C3 16.866 7.122 21 12.208 21c4.13 0 7.625-2.727 8.792-6.484M22 12c0-5.523-4.477-10-10-10\" stroke-linecap=\"round\" /><path stroke-linejoin=\"round\" d=\"M12 2v10h10\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol